import { render, staticRenderFns } from "./variant-details.vue?vue&type=template&id=008ee885&scoped=true"
import script from "./variant-details.vue?vue&type=script&lang=js"
export * from "./variant-details.vue?vue&type=script&lang=js"
import style0 from "./variant-details.vue?vue&type=style&index=0&id=008ee885&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008ee885",
  null
  
)

export default component.exports